<rl-please-wait *ngIf="blockView" [disable]="true"></rl-please-wait>
<div class="media-body">
    <div class="media-heading">
        <div class="citation-title justify-content">
            <div class="flex-start">
                <h1 class="media-title">
                    {{asgmt.title}}
                    <rl-due-date *ngIf="asgmt.dueDate" [date]="asgmt.dueDate"></rl-due-date>
                </h1>
            </div>
            <div class="flex-end">
                <div class="justify-content ie-inline flex-wrap">
                    <div class="flex-basis">
                        <button class="btn btn-half-clear half-margin-right" [ngClass]="{'disabled': !gradesToPost}" [disabled]="!gradesToPost" (click)="sendToLms()" [tooltip]="postGradesTooltip" placement="auto" id="post-scores" [rlAria] [rlTabIndex]>
                            {{ 'asgmt.view.postScores' | translate}}
                        </button>
                    </div>
                    <div class="flex-basis">
                        <button [ngClass]="{'disabled' : !asgmt.statistics?.needToGrade}" class="btn btn-primary" [disabled]="!asgmt.statistics?.needToGrade" (click)="startGrading()" [tooltip]="'asgmt.view.startGrading.tooltip' | translate" placement="auto" id="start-grading" [rlAria] [rlTabIndex]>
                            {{ 'asgmt.view.startGrading' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <button class="btn btn-link no-padding" id="view-assignment" (click)="viewAssignment.emit()" [rlAria]="'asgmt.view.viewAssignment' | translate" [rlTabIndex]>
            {{'asgmt.view.viewAssignment' | translate}}
        </button>
    </div>
</div>
<p class="error-message" *ngIf="asgmt.sanitizeFile"><i class="fa fa-ban"></i><span [innerHtml]="'asgmt.file.copyright.not.approved.msg.instructor' | translate"></span></p>
<div *ngIf="!busy" class="justify-content ie-inline flex-wrap stat-box-line">
    <rl-counter-button (onClick)="filter()" class="flex-basis all-students double-margin-right" [text]="'asgmt.statistics.allStudents' | translate" [counter]="asgmt.statistics.total" [total]="asgmt.statistics.total" [hideBar]="true"></rl-counter-button>
    <rl-counter-button (onClick)="filter('NOT_SUBMITTED')" class="flex-basis didnt-submit double-margin-right" [text]="'asgmt.statistics.didntSubmit' | translate" [counter]="asgmt.statistics.didntSubmit" [total]="asgmt.statistics.total"></rl-counter-button>
    <rl-counter-button (onClick)="filter('NOT_GRADED')" class="flex-basis need-grade double-margin-right" [text]="'asgmt.statistics.needToGrade' | translate" [counter]="asgmt.statistics.needToGrade" [total]="asgmt.statistics.total"></rl-counter-button>
    <rl-counter-button (onClick)="filter('GRADED', 'PUBLISHED')" class="flex-basis graded double-margin-right" [text]="'asgmt.statistics.graded' | translate" [counter]="asgmt.statistics.graded" [total]="asgmt.statistics.total"></rl-counter-button>
    <rl-counter-button  class="flex-basis" [text]="'asgmt.statistics.avg' | translate" [counter]="asgmt.statistics.avg" [total]="asgmt.lmsAssignmentMaxScore" [hideBar]="true"></rl-counter-button>
</div>
<div class="justify-content ie-inline flex-wrap">
    <div class="flex-basis">
        <rl-search (onSearch)="search($event)" [options]="studentsNames" class="search-users"></rl-search>
    </div>    
    <div class="flex-basis">
        <button class="btn btn-clear" id="refreshPage" (click)="refresh()" [tooltip]="'btn.refresh' | translate" [rlAria] [rlTabIndex]>
            <i class="fa fa-refresh"></i>
            <span class="sr-only">{{'collection.tooltip.refresh_this_page' | translate}}</span>
        </button>
    </div>
    <!-- <div class="flex-basis">
        <button class="btn btn-clear" id="veiwStats" attr.aria-label="View assignment statistics" [tooltip]="'View assignment statistics'" tooltip-trigger="'focus mouseenter'" tooltip-placement="auto" tabindex="0">
            <i class="fa fa-bar-chart"></i>
            <span class="sr-only">View assignment statistics</span>
        </button>
    </div> -->
</div>
<rl-please-wait *ngIf="busy"></rl-please-wait>
<table *ngIf="!busy" class="table table-striped info-table">
    <caption class="sr-only">{{'assignment.view.students.list' | translate}}</caption>
    <tbody>
        <tr>
             <th scope="col">
                <div class="justify-content ie-inline flex-wrap">
                    <div class="flex-basis half-margin-right">
                        {{'assignment.view.students.list.name' | translate}}
                    </div>
                    <rl-sort-buttons [dir]="'asc'" (onSort)="sort('user.family_name', $event)" [group]="'asgmtInstStat'" [name]="'familyName'"></rl-sort-buttons>
                </div>
             </th>
             <th scope="col">
                <div class="justify-content ie-inline flex-wrap">
                    <div class="flex-basis half-margin-right">
                        {{'assignment.view.students.list.status' | translate}}
                    </div>
                    <rl-sort-buttons (onSort)="sort('status', $event)" [group]="'asgmtInstStat'" [name]="'status'"></rl-sort-buttons>
                </div>
             </th>
             <th scope="col">
                <div class="justify-content ie-inline flex-wrap">
                    <div class="flex-basis half-margin-right">
                        {{'assignment.view.students.list.dateSubmitted' | translate}}
                    </div>
                    <rl-sort-buttons (onSort)="sort('submission.userSubmissionDate', $event)" [group]="'asgmtInstStat'" [name]="'userSubDate'"></rl-sort-buttons>
                </div>
             </th>
             <th scope="col">
                <div class="justify-content ie-inline flex-wrap">
                    <div class="flex-basis half-margin-right">
                        {{'assignment.view.students.list.score' | translate}}<ng-container *ngIf="asgmt.lmsAssignmentMaxScore">/{{asgmt.lmsAssignmentMaxScore}}</ng-container>
                    </div>
                    <rl-sort-buttons (onSort)="sort('submission.grade', $event)" [group]="'asgmtInstStat'" [name]="'grade'"></rl-sort-buttons>
                </div>
             </th>
             <th scope="col">{{'assignment.view.students.list.gradeComments' | translate}}</th>
        </tr>
        <p class="label-warning" *ngIf="!filteredStudentsList.length; else submissions"><i class="fa fa-exclamation-triangle"></i> {{'assignment.view.students.not.found' | translate}}</p>
        <ng-template #submissions>
            <tr *ngFor="let s of filteredStudentsList; let i=index">
                <td>
                    <span [ngClass]="{'label-warning' : isLateSubmission(s.submission)}">
                        <span *ngIf="isLateSubmission(s.submission)">
                            <i class="fa fa-info-circle"></i>
                        </span>
                        {{s.user.family_name}} {{s.user.given_name}}
                    </span>
                </td>
                <td>
                    <span class="semibold-text" [ngClass]="getStatusClass(s.status)">{{'asgmt.sub.status.' + s.status | translate}}</span>
                </td>
                <td>
                    <ng-container *ngIf="s.submission">
                        <span class="oblique">{{s.submission?.userSubmissionDate | customerDateTime}}</span> 
                        (<button class="btn btn-link no-padding" (click)="openStudentSubmission(s)" [rlAria]="'assignment.students.list.submission.view' | translate" id="view-assignment" [rlTabIndex]>
                            {{'assignment.students.list.submission.view' | translate}}
                        </button>)
                    </ng-container>
                </td>
                <td class="ContentSummary grade-input">
                    <input *ngIf="s.submission" class="form-control border-bottom-input input-reset" type="number" name="grade" id="final-grade" [ngModel]="s.submission.grade" (ngModelChange)="newGradeToUpdate=$event" (change)="updateGrade(s)" [max]="asgmt.lmsAssignmentMaxScore"/>
                </td>
                <td class="free-text-td">{{s.submission?.feedback}}</td>
            </tr>
        </ng-template>
    </tbody>
</table>